import { h } from "@stencil/core";
const render = () => (h("iframe", { src: "/showcase/pages/tabular-grid.html", frameborder: "0" }));
export const tabularGridShowcaseStory = {
    render: render
};
